import { render, staticRenderFns } from "./OrderFirstInfo.vue?vue&type=template&id=69989654&"
import script from "./OrderFirstInfo.vue?vue&type=script&lang=ts&"
export * from "./OrderFirstInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports